
import { defineComponent, PropType, provide } from 'vue';
import { useVModel } from 'vue-composable';
import { useStore } from '@/store';
import { Client } from '@/types/app';
import { InjectionKeys } from '@/constants';
import AppModal from '@/components/modal/base/AppModal.vue';

export default defineComponent({
  name: 'ClientDeleteFormModal',
  emits: ['update:openState'],
  components: {
    AppModal
  },
  props: {
    openState: {
      type: Boolean,
      required: true
    },
    client: {
      type: Object as PropType<Client>
    }
  },
  setup(props) {
    const isOpen = useVModel(props, 'openState');

    const store = useStore();
    const submit = async () => props.client && store.dispatch.clients.delete(props.client);

    provide(InjectionKeys.FormSubmit, submit);

    return {
      isOpen
    };
  }
});
